import React, { useState, useEffect } from "react";
import { IonInput } from "@ionic/react";
import nextButton from "../../../assets/images/nextz.svg";
import nextButtonGrey from "../../../assets/images/next_grey.png";

import whiteBack from "../../../assets/icons/arrow-back.png";
import userService from "../../../services/UserService";
import { isValidEmail } from "../../../utils/helperMethods";
import AuthenticationService from "../../../services/AuthenticationService";
import { useSelector } from "react-redux";

const errObj = [
  { msg: "Organisation not registered with us", code: 0, isGreen: false },
  { msg: "Please enter a valid email address", code: 1, isGreen: false },
  { msg: "Invalid OTP.", code: 2, isGreen: false },
  { msg: "Please enter a valid email address", code: 3, isGreen: false },
  {
    msg: "A new OTP has been sent to your email address.",
    code: 4,
    isGreen: true,
  },
];

const OrganisationCodeComponent = (props) => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [err, setErr] = useState(null);
  const [otpVis, setOtpVis] = useState(false);
  const [shouldEnable, setshouldEnable] = useState(true);
  const [otpTimer, setOtpTimer] = useState(60);
  const [shouldTimerChange, setShouldTimerChange] = useState(0);
  const [resendVisible, setResendVisible] = useState(false);
  const loginStore = useSelector((store) => store.login);
  const { user } = loginStore;

  const handleEmailInputChange = (e) => {
    setEmail(e.target.value);
    if (err) {
      setErr(null);
    }
  };
  const handleOtpInputChange = (e) => {
    setOtp(e.target.value);

    if (err) {
      setErr(null);
    }
  };

  useEffect(() => {
    function otptime() {
      if (otpTimer > 0) {
        setOtpTimer(otpTimer - 1);
      } else {
        setShouldTimerChange(0);
        setResendVisible(true);
      }
    }
    if (shouldTimerChange !== 0) {
      let id = setTimeout(otptime, 1000);
      return () => {
        clearTimeout(id);
      };
    }
  }, [otpTimer, shouldTimerChange]);

  const handleSubmission = (isResend) => {
    if (!isValidEmail(email)) {
      handleError(1);
    } else {
      setshouldEnable(false);

      let params = { userId: user.id, emailId: email.trim() };
      userService
        .postOrgEmail(params)
        .then((res) => {
          setShouldTimerChange(1);
          setOtpVis(true);
          setResendVisible(false);
          setOtpTimer(60);
          if (isResend) {
            setErr(errObj[4]);
          }
        })
        .catch((err) => {
          setshouldEnable(true);
          if (err.response?.status === 422) {
            setErr(errObj[0]);
          } else {
            setErr({ msg: err.message, code: 4 });
          }
        });
    }
  };

  const handleDone = () => {
    let params = { userId: user.id, emailId: email, otp: parseInt(otp) };
    userService
      .verifyOrgEmail(params)
      .then((res) => {
        props.handleClose("done", email);
      })
      .catch((err) => {
        setErr(errObj[2]);
      });
  };

  const handleError = (errCode) => {
    setErr(errObj[errCode]);
    // setTimeout(() => {
    //   setErr(null);
    // }, 5000);
  };

  return (
    <div className="organisation-code-component-container">
      <p className="fw-semibold">
        Add your work email to get access to special health benefits
      </p>
      <div
        className={`organisation-email-container ${
          shouldEnable ? "" : "organisation-email-container-disabled"
        }`}
      >
        <div className="organisation-email-container-heading">
          <span
            style={{
              color: `${email.length > 0 && shouldEnable ? "#97144D" : ""}`,
            }}
          >
            Here is my email address
          </span>
          {!shouldEnable && (
            <span
              style={{
                color: "#97144D",
                fontWeight: "bolder",
                textDecoration: "underline",
              }}
              onClick={() => {
                setshouldEnable(true);
                setOtpVis(false);
                setOtp("");
              }}
            >
              Change?
            </span>
          )}
        </div>

        <div className="organisation-email-input">
          <input
            disabled={shouldEnable ? false : true}
            placeholder="abc@company.in"
            type="text"
            name="email"
            value={email}
            onChange={(e) => {
              handleEmailInputChange(e);
            }}
          />
          <img
            src={email.length > 0 && shouldEnable ? nextButton : nextButtonGrey}
            alt="next-icon"
            onClick={() => {
              if (shouldEnable) {
                handleSubmission();
              }
            }}
          />
        </div>
      </div>
      {otpVis && (
        <div className="organisation-otp-input">
          <IonInput
            name="otp"
            type="tel"
            inputmode="tel"
            placeholder="Enter OTP"
            value={otp}
            maxlength={5}
            size="5"
            onIonChange={(e) => handleOtpInputChange(e)}
          ></IonInput>
        </div>
      )}

      {err && (
        <div className={`organisation-message-box`}>
          <div
            className={`organisation-message-box-error ${
              err.isGreen ? "organisation-message-box-green" : ""
            }`}
          >
            <p>{err.msg}</p>
          </div>
          {err.code === 0 && (
            <p
              className="organisation-not-verified-error"
              onClick={() => props.handleClose("error")}
            >
              Continue with another source
            </p>
          )}
        </div>
      )}

      <div className="organisation-code-otp-msg">
        {otpVis ? (
          <div className="organisation-code-otp-msg-2">
            <span>
              {`If you do not receive the OTP in ${otpTimer} seconds,`}
            </span>
            <br />
            <span>click</span>
            <span
              className={`${
                resendVisible ? "text-underline-class" : ""
              } otp-msg-resend-button`}
              onClick={() => {
                if (resendVisible) {
                  handleSubmission(true);
                }
              }}
            >
              Resend
            </span>
          </div>
        ) : (
          <p>You will receive a 5-digit OTP on your work email address</p>
        )}
      </div>
      <button
        className="organisation-submit-button"
        disabled={otp.length === 5 ? false : true}
        onClick={() => {
          handleDone();
        }}
      >
        Done
      </button>
      <div
        className={`organisation-close ${
          window.Capacitor.platform === "web"
            ? "dialog-close-button-height-web"
            : ""
        }`}
        onClick={() => {
          props.handleClose("cross");
        }}
      >
        <img src={whiteBack} alt="back-icon" />
        <span>Back</span>
      </div>
    </div>
  );
};

export default OrganisationCodeComponent;
